import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import {
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Click Get Started",
    description:
      "Click Get Started on your desktop, laptop, or mobile device to begin.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect your New York Rangers account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Games",
    description:
      "Select the games you wish to attend based on the amount of credit you have available.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the New York Rangers program work?",
    description:
      "The New York Rangers Flex program allows fans to select any seat to any game. Simply log into your New York Rangers Account manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "No. You have the opportunity to select all the games you’d like to attend throughout the season. This is subject to change.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "How many tickets can I select for each game?",
    description:
      "Flex Plan customers are eligible to redeem up to 4 tickets per game.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your New York Rangers Account Manager within an hour of selection.",
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function TopNavMenuItems() {
  const user = useAppStore(selectUser);

  return (
    <Box>
      {user ? <Divider /> : null}
      <MenuList>
        <MenuItem
          onClick={() => {
            window.open("https://flex2.seasonshare.com/knicks", "_blank");
          }}
        >
          <ListItemIcon>
            <OpenInNewRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>NY KNICKS FLEX BANK</ListItemText>
        </MenuItem>
      </MenuList>
    </Box>
  );
}
